import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types';
import { env } from '@/config/env.config';

const supabaseUrl = env.VUE_APP_SUPABASE_URL as string;
const supabaseAnonKey = env.VUE_APP_SUPABASE_ANON_KEY as string;
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);
